<template>
  <div>

    <PointToPointDetail1R
      v-if="is1r"
      :detail="detail"
    ></PointToPointDetail1R>

  </div>
</template>

<script>
import {mapState} from 'vuex';
import PointToPointDetail1R from "./P2p1r/PointToPointDetail1R";

export default {
  name: "PointToPointDetail",
  components: {
    PointToPointDetail1R,
  },
  computed: {
    ...mapState('p2p', ['detail']),
    is1r() {
      if (!this.detail) {
        return false;
      }

      return this.detail.type === '1r';
    },

  },
  methods: {

    // get ETA for the starting stop
    getEta() {

    },
  },
}
</script>

<style scoped>

</style>
